import React from "react";
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-router-dom';
import { toLowerCasePath } from '../extensions/utilityExtensions';

import Copyright from "./copyright";

import { SiDiscord, SiTiktok } from "react-icons/si";
import {
  LiaYoutube,
  LiaArtstation,
  LiaPinterestP,
  LiaInstagram,
  LiaBehance,
  LiaFacebookF,
  LiaPatreon,
  LiaDiscord,
} from "react-icons/lia";

import "./styles/footer.css"
import "./styles/containers.css"
import "./styles/images.css"

function Footer() {
  const isMobileLarge = useMediaQuery({ query: '(height > 1616px)' });

  return (
    <footer>
      <img className="footerBackground" src="../images/Backgrounds/lower-banner-02.png" alt="" />
      <div className="footerSection">
        <h3 className={`textBold footerElement ${isMobileLarge ? "fontSize45px" : "fontSize30px"}`}>Razul Artworks</h3>
        <div className="footerSocialContainer footerElement">
          <a
            className="social-icon"
            href="https://www.youtube.com/@RazulArtworks"
            target="_blank"
          >
            <LiaYoutube size={`${isMobileLarge ? "3em" : "1.65rem"}`} />
          </a>

          <a
            className="social-icon"
            href="https://www.artstation.com/razulartworks"
            target="_blank"
          >
            <LiaArtstation size={`${isMobileLarge ? "3em" : "1.65rem"}`} />
          </a>

          <a
            className="social-icon"
            href="https://co.pinterest.com/RazulArtworks"
            target="_blank"
          >
            <LiaPinterestP size={`${isMobileLarge ? "3em" : "1.65rem"}`} />
          </a>

          <a
            className="social-icon"
            href="https://www.instagram.com/razulartworks"
            target="_blank"
          >
            <LiaInstagram size={`${isMobileLarge ? "3em" : "1.65rem"}`} />
          </a>

          <a
            className="social-icon"
            href="https://www.behance.net/razulartworks"
            target="_blank"
          >
            <LiaBehance size={`${isMobileLarge ? "3em" : "1.65rem"}`} />
          </a>

          <a
            className="social-icon"
            href="https://www.facebook.com/RazulArtworks"
            target="_blank"
          >
            <LiaFacebookF size={`${isMobileLarge ? "3em" : "1.65rem"}`} />
          </a>

          <a
            className="social-icon"
            href="https://www.tiktok.com/@razulartworks"
            target="_blank"
          >
            <SiTiktok size={`${isMobileLarge ? "3em" : "1.65rem"}`} />
          </a>

          {/* <a
            className="social-icon"
            href="https://www.patreon.com/RazulArtworks"
            target="_blank"
          >
            <LiaPatreon size={`${isMobileLarge ? "3em" : "1.65rem"}`} />
          </a> */}
          {/* <a
            className="social-icon"
            href="https://discord.gg/h6Ja88Xw"
            target="_blank"
          >
            <SiDiscord size={`${isMobileLarge ? "3em" : "1.65rem"}`} />
          </a> */}
        </div>
        <div className="footer-nav">
          <Link to={toLowerCasePath("/privacy-and-cookies")} className="footer-link">Privacy Policy</Link>
        </div>
        <div className="footerElement">
          <Copyright />
        </div>
      </div>
    </footer>
  );
}

export default Footer;
